import React from "react";

export const TransactionSaveBtn = ({ canClick, isLoading, actionText }) => (
  <button
    value="submit"
    className={`w-1/3 h-16 mt-4 rounded-md text-2xl text-black ${
      canClick
        ? "text-white bg-[#eed495]"
        : "bg-[#545454] "
    }`}
  >
    {isLoading ? "Adding" : actionText}
  </button>
);
